import React, {useEffect, useState, useCallback} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {isEmpty, uniqueId, orderBy as orderByLoadash} from 'lodash';
import styled from 'styled-components';
import * as actions from '../../../store/actions';
import { i18n } from '../../../translate/i18n';
import {
  Typography, IconButton, FormControl, Checkbox, FormControlLabel
} from '@mui/material';
import {withRouter} from 'react-router-dom';

import CloseIcon from '@mui/icons-material/Close';

import {
  FormStyled, DoneIconStyled, DivSubmitButtons, DivFormTitle,
} from '../Forms/styles';

import {
	InputMessageErrorText,
} from './styles';

import Autocomplete from '../../../UI/Autocomplete/Autocomplete';
import Spinner from '../../../components/Spinner/index';
import confirm from '../../../UI/Confirm/confirm';

const ModalCloneChecklistSite = (props) => {
  	const dispatch = useDispatch();

	const postCloneChecklist = (body, id) =>
		dispatch(actions.postCloneChecklistBySite(body, id));


	// selected values on autocomplete
	const [sitesFormated, setSitesFormated] = useState([]);

	const [selectedSitesFrom, setSelectedSitesFrom] = useState([]);
	const [selectedSitesTo, setSelectedSitesTo] = useState([]);

	const [sitesFromError, setSitesFromError] = useState(false);
	const [sitesToError, setSitesToError] = useState(false);
	const [sitesToErrorMessage, setSitesToErrorMessage] = useState("");

	const [equipmentServices, setEquipmentServices] = useState({});

	const selectedAccess = useSelector(state => state.auth.selectedAccess);
	const sites = useSelector(state => state.sites.allSites);
	const equipmentModel = useSelector(state => state.equipmentModels.equipmentModel);

	const loading = useSelector(state => state.equipmentModels.loadingChecklistClone);

  	// FUNCTION TO FORMAT FIELD OF ACTIVITIES AND AREAS TYPES IN THE AUTOCOMPLETE
  	useEffect(() => {
		const dataFromRedux = sites;
		const returnArray = [];
		dataFromRedux.rows.map((dt) =>
		returnArray.push({ value: dt._id, label: dt.name })
		);
		setSitesFormated(returnArray);
	}, [sites]);

	useEffect(() => {
		setEquipmentServices(equipmentModel.equipmentServices);
	}, [equipmentModel]);

  const handleSubmit = async (e) => {
		e.preventDefault();
		let hasError = false;

		if (isEmpty(selectedSitesFrom)) {
			setSitesFromError(true);
			hasError = true;
		}

		if (isEmpty(selectedSitesTo)) {
			setSitesToError(true);
			hasError = true;
		}

		if (hasError) return;

		let sitesTo = [];
    selectedSitesTo.map(s => sitesTo.push(s.value))

		const body = {
			siteFrom: selectedSitesFrom.value,
			sitesTo: sitesTo,
			services: equipmentServices.filter((e) => (e.checked)).map(service => service._id)
    };


		postCloneChecklist(body, props.equipmentModel._id)
		.then((result) => {
			if (result !== 'error') {
				props.closeModal(false, '');
				dispatch(actions.postCloneChecklist);
			}
		}).catch(err => {
			setSitesToError(true);
			setSitesToErrorMessage(`${err.site} ${i18n.t('setSitesToErrorMessageModalCloneCheck.errSite')}`);
		});
  };

  	const handleInputChangeSitesFrom = (selected) => {
    	setSitesFromError(false);
		setSelectedSitesFrom(selected);
		setSelectedSitesTo([]);
	};

	const handleInputChangeSitesTo = (selected) => {
		setSitesToErrorMessage('');
		setSitesToError(false);
		setSelectedSitesTo(selected);
	};

	const handleClickCheckbox = (es) => {
		setEquipmentServices(prevState => {
			const equip = prevState.find(equipServ => equipServ._id === es._id)
			equip.checked = !equip.checked;

			return [
				...prevState,
			]
		})
	}

  return <>
    <FormStyled onSubmit={handleSubmit} style={{ ...styles.opacityContainer, opacity: loading ? '0.3' : '1' }}>
          {loading && <Spinner overlay />}
          <DivFormTitle>
              <Typography variant="h6">
                  {i18n.t('typographyModalCloneCheckSite.text')}
              </Typography>
          </DivFormTitle>
              <FormControl variant="standard" fullWidth margin="normal" required>
              <div>{i18n.t('formControlModalCloneCheckSite.from')}</div>
              <Autocomplete
                  // label="Clonar De:"
                  data={sitesFormated} // sent to options
                  onSelectValue={handleInputChangeSitesFrom} // sent to onChange
                  valueSelected={selectedSitesFrom} // sent to value
                  newSearchText={() => {}}
                  name="site"
                  hasError={sitesFromError}
              />
          </FormControl>
              {selectedSitesFrom && selectedSitesFrom.value &&
              <>
                  <FormControl variant="standard" fullWidth margin="normal" required>
                      <div>{i18n.t('formControlModalCloneCheckSite.text')}</div>
                      {equipmentServices.map(es => (
                          <div key={es._id} style={styles.serviceTypesContainer}>
                              <FormControlLabel
                                  label={es.serviceType.name + ' / ' + es.frequency.name}
                                  control={<Checkbox
                                          onChange={() => handleClickCheckbox(es)}
                                          checked={!!es.checked} />}
                              />
                          </div>
                      ))}
                  </FormControl>
                      <FormControl variant="standard" fullWidth margin="normal" required>
                      <div>{i18n.t('formControlModalCloneCheckSite.to')}</div>
                      <Autocomplete
                          // label="Clonar Para:"
                          data={sitesFormated.filter(site => site.value !== selectedSitesFrom.value && selectedAccess.sites.find(s => s._id === site.value))} // sent to options
                          onSelectValue={handleInputChangeSitesTo} // sent to onChange
                          valueSelected={selectedSitesTo} // sent to value
                          newSearchText={() => {}}
                          hasError={sitesToError}
                          isMulti
                      />
                      {sitesToError && <InputMessageErrorText>{sitesToErrorMessage}</InputMessageErrorText>}
                  </FormControl>
              </>}
              <DivSubmitButtons>
              <IconButton onClick={() => props.closeModal()} size="large">
                  <CloseIcon fontSize="large" color="error" />
              </IconButton>
              <IconButton type="submit" size="large">
                  <DoneIconStyled fontSize="large" />
              </IconButton>
          </DivSubmitButtons>
      </FormStyled>
  </>;
};

export default withRouter(ModalCloneChecklistSite);

const TypographyHover = styled(Typography)`
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;

const styles = {
	opacityContainer: {
		position: 'relative',
	},
	groupContainer: {
		display: 'flex',
		alignItems: 'center',
	},
	icon: {
		marginLeft: 5,
		cursor: 'pointer',
		fontSize: '1.5rem',
	},
	groupLabel: {
		fontWeight: 'bold',
	},
	createButton: {
		marginLeft: 20,
		background: '#bbd2ca',
		border: 'none',
		fontSize: 11,
		fontWeight: 400,
		borderRadius: 15,
		padding: '5px 10px 5px 10px',
		cursor: 'pointer',
	},
	serviceTypesContainer: {
		display: 'flex',
	}
};
